import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BufSpan from './BufSpan';
import AnalogClock from '../footer/AnalogClock';
import Themes from '../themes/Themse';
import { TbColorSwatch } from 'react-icons/tb';
import NavLink from './NavLink';
import useKiponosNavigator, { getPage, isKnownPath } from '../../hooks/useKiponosNavigator';
import { useOperatorContext } from '../login/OperatorContextProvider';
import './SideBar.css';

export default function SideBar() {
  const {isOperatorReady, operatorState}  = useOperatorContext();
  const {PageKeys, navTo}                 = useKiponosNavigator();
  //const [firstTime, setFirstTime]         = useState(true);
  const [loggedIn, setLoggedIn]           = useState(isOperatorReady());

  useEffect(()=>{
    setLoggedIn(isOperatorReady());
  }, [operatorState, isOperatorReady]);
  
  const getNavLinks = useCallback(() => {
    return Object.keys(PageKeys)
          .filter(pageKey => getPage(pageKey).isSideBar)
          .filter(pageKey => {
            return !loggedIn || (loggedIn && pageKey !== PageKeys.SIGNUP && pageKey !== PageKeys.LOGIN);
          })
          .map(pageKey => {
                return <NavLink pageKey={PageKeys[pageKey]} key={pageKey}/>;
          })
  }, [PageKeys, loggedIn]);

  const navLinks = useMemo(() => getNavLinks(), [getNavLinks]);
    
  useEffect(() => {
      const currentPath = window.location.pathname;
      const isAuthPath = Object.keys(PageKeys)
            .map(pageKey => getPage(pageKey))
            .filter(page => page.auth)
            .some(page => page.path === currentPath);
      const isKnown = isKnownPath(currentPath);
      //console.log('[SideBar Effect] [path: %s] [isKnown: %s] [isAuthPath: %s] [loggedIn: %s]',currentPath, isKnown, isAuthPath, loggedIn);
      
      if (!isKnown || (isAuthPath && !loggedIn)) {
        navTo(PageKeys.LOGIN, true);
      }
  }, [navTo, PageKeys.LOGIN, PageKeys, loggedIn]);
   
  return (
    <div className='sideBarMain'>
      <div className='navControl'>
        {navLinks}
      </div>
      
      <div className='settingsControl'>
        <div style={{marginTop:24}}>
          <div style={{paddingLeft: 8}}><TbColorSwatch/> <BufSpan/> Themses</div>
          <div style={{marginLeft: 16, marginTop: 8}}>
            <Themes />
          </div>
        </div>

        <div style={{paddingTop: 64}}>
        </div>
        <AnalogClock />
      </div>
    </div>
  )
}

// Very Nice Checkmark: <GiCheckMark/>   import { GiCheckMark } from 'react-icons/gi';
// import { BsToggles } from 'react-icons/bs';
// <MyAuthLink to='/settings'> <GoSettings/> <BufSpan/> Settings </MyAuthLink>
// <MyAuthLink to='/todo'> <GoTasklist/> <BufSpan/> Todo </MyAuthLink>
// <MyAuthLink to='/access'> <GoGear/> <BufSpan/> Permissions </MyAuthLink>
// <MyAuthLink to='/vault'> <GoGear/> <BufSpan/> Vault </MyAuthLink>
// <MyAuthLink to='/team'> <AiOutlineTeam /> <BufSpan/> Team </MyAuthLink>
// <MyAuthLink to='/account'> <CgWorkAlt/><BufSpan/> Account </MyAuthLink>
// <MyAuthLink to='/team-ctrl'> <AiOutlineTeam/> <BufSpan/> Team </MyAuthLink>
//import { RiTeamFill } from "react-icons/ri";
//import { LiaUsersSolid } from "react-icons/lia";
// , GoSettings, GoTasklist,  BsBroadcast react-icons/bs